<template>
  <div class="ushk-footer">
    <div class="ushk-wrap ushk-wrap-main">
      <div class="ushk-footer__wrap">
        <div class="ushk-footer__l ushk-footer__link">
          <dl>
            <dd v-for="item in links" :key="item.name">
              <a :href="item.link ? item.link : '#'" :target="item.link ? '_blank' : ''">{{ item.name }}</a>
            </dd>
          </dl>

          <div class="app-info">
            <span v-for="item in appInfo">{{ item.label }}</span>
            <a href="./permissions.html" target="_blank">权限详情</a>
            <a href="https://www.ushknews.com/app_pages/privacy_agreement.html" target="_blank">隐私协议</a>
          </div>
        </div>

        <div class="ushk-footer__r ushk-footer__copyright">
          <p>金十数据 广州金十信息科技有限公司 版权所有
          </p>
          <p>Copyright © 2013 - 现在 Jin10.com All Rights Reserved</p>
          <p>
            <a href="http://beian.miit.gov.cn" target="_blank">粤ICP备16010774号-5</a>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010502002893" target="_blank">
              <img src="https://cdn.jin10.com/assets/img/commons/gonganbeian.png" alt="" width="13" style="vertical-align: middle;">
              粤公网安备44010502002893号
            </a>
          </p>
        </div>
      </div>
      <div class="ushk-footer__wrap">
        <div class="ushk-footer__r ushk-footer__renzheng">
          <p v-for="(item, index) in certifications" :key="index">
            <a :href="item.link" target="_blank">
              <img width="48" height="20" :src="item.img" :srcset="item.img2x + ' 2x'">
            </a>
          </p>
          <div class="ushk-footer__counselor">
            <i class="ushk-icon ushk-icon_counselor"></i>
            <span>常年法律顾问：广东踔厉律师事务所</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapState, mapMutations, mapGetters, mapActions} from 'vuex'

export default {
  name: '',
  computed: {

    ...mapGetters(['isVideoPlaying'])
  },
  data () {
    return {
      links: [{
        name: '下载APP',
        link: 'https://www.ushknews.com/app/index.html'
      },
      {
        name: '联系我们',
        link: 'https://www.jin10.com/about/index.html#contact'
      },
      {
        name: '广告合作',
        link: 'https://www.jin10.com/about/index.html#cooperation'
      },
      {
        name: '数据引用',
        link: 'http://south.jin10.com/example/websiteiframe.html'
      },
      {
        name: '人才招聘',
        link: 'https://jobs.jin10.com/#/'
      },
      {
        name: '意见反馈',
        link: 'http://crm2.qq.com/page/portalpage/wpa.php?uin=800185710&cref=https%3A%2F%2Fid.b.qq.com%2Fcrm%2Findex.php%3Frr%3Dwpa&ref=https%3A%2F%2Fid.b.qq.com%2Fcrm%2Findex.php%3Frr%3Dwpa%2Fstyle%26id%3Dwpa_setting_a01&pt=undefined&f=1&ty=1&ap=&as=&aty=0&a='
      },
      {
        name: '版权声明',
        link: 'https://www.jin10.com/about/index.html#privacy'
      }
      ],
      certifications: [{
        img: require('../assets/img/commons/footer/certification.png'),
        img2x: require('../assets/img/commons/footer/certification@2x.png'),
        link: 'http://v.pinpaibao.com.cn/authenticate/cert/?site=www.jin10.com&at=business'
      },
      {
        img: require('../assets/img/commons/footer/renzhenglianmeng.png'),
        img2x: require('../assets/img/commons/footer/renzhenglianmeng@2x.png'),
        link: 'http://si.trustutn.org/info?sn=142160203020335292461&certType=1'
      },
      {
        img: require('../assets/img/commons/footer/kexinwangzhan.png'),
        img2x: require('../assets/img/commons/footer/kexinwangzhan@2x.png'),
        link: '//www.jin10.com/knet.html'
      }/*,
      {
        img: require('../assets/img/commons/footer/chengxinwangzhan.png'),
        img2x: require('../assets/img/commons/footer/chengxinwangzhan@2x.png'),
        link: '//www.jin10.com/cecdc.html'
      } */
      ],
      appInfo: [{
        label: '应用名称：美港电讯'
      }, {
        label: '应用版本：1.8.0'
      }, {
        label: '开发者：广州金十信息科技有限公司'
      }, {
        label: '更改时间：2021.05.21'
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// Footer.vue?785069be